<script setup lang="ts">
import { onMounted } from 'vue'
import { useAdminAuth } from './stores/auth'

const auth = useAdminAuth()
onMounted(() => auth.init())
</script>

<template>
  <RouterView />
</template>
